import React from 'react'
import * as styles from './PlatformSwitcher.module.scss'
import CodinGame from './CodinGame'
import CoderPad from './CoderPad'

const PlatformSwitcher: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.platform}>
        <CodinGame />
      </div>
      <div className={styles.platform}>
        <CoderPad />
      </div>
      <div className={styles.toggle} />
    </div>
  )
}

export default PlatformSwitcher
